import React from 'react';
import * as Yup from 'yup';

export const TaskTimeValidatorSchema = Yup.object().shape({
    minutes: Yup.number()
        .required('required').min(0, 'min0')
});